import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-custom-checkbox-with-title-and-subtitle',
  templateUrl: './custom-checkbox-with-title-and-subtitle.component.html',
  styleUrls: ['./custom-checkbox-with-title-and-subtitle.component.css'],
})
export class CustomCheckboxWithTitleAndSubtitleComponent implements OnInit {
  @Input() title: string = '';
  @Input() subtitle: string = '';
  @Input() titleFontSize: string = '20px';
  @Input() subtitleFontSize: string = '14px';
  @Input() checkboxSize: string = '32px';
  @Input() textPaddingLeft: string = '25px';
  @Input() titlePaddingtop: string = '0px';
  @Input() defaultValue: boolean = false;
  @Input() padding: string = '0px';
  @Input() value: boolean = false;
  @Input() disableDefaultCheckEvent: boolean = false;
  @Output() onValueChange = new EventEmitter<boolean>();
  @Output() click = new EventEmitter<boolean>();

  constructor() {}

  ngOnInit(): void {
    if(this.defaultValue)
      this.value = true;
  }

  handleValueChange() {
    if(!this.disableDefaultCheckEvent){
      this.value = !this.value;
      this.onValueChange.emit(this.value);
    }
    this.click.emit(this.value);
  }
}
